import React, { useState } from 'react';
// Using a placeholder image URL to prevent build errors
// Replace with your actual map image path when available
//const mapImage = '../assets/images/coverage-map.jpg'; // Placeholder image URL
// If you want to use a local image, uncomment the line below and create the assets/images directory
import mapImage from '../assets/images/coverage-map.jpg';

const Coverage = () => {
  const [activeTab, setActiveTab] = useState('Mian Channu');

  const cities = [
    { id: 'Mian Channu', name: 'Mian Channu', speed: '50 Mbps', coverage: '95%' },
    { id: 'Vajian wala', name: 'Vajian wala', speed: '50 Mbps', coverage: '92%' },
    { id: '59 Pul', name: 'Lahore', speed: '50 Mbps', coverage: '85%' },
    { id: 'Jandial Bangla', name: 'Karachi', speed: '50 Mbps', coverage: '82%' },
  ];

  const features = [
    { 
      icon: 'fa-shield-alt',
      title: '99.9% Uptime',
      description: 'Guaranteed network reliability with our redundant infrastructure'
    },
    { 
      icon: 'fa-headset',
      title: '24/7 Support',
      description: 'Round-the-clock technical assistance from our expert team'
    },
    { 
      icon: 'fa-bolt',
      title: 'Lightning Fast',
      description: 'Blazing fast speeds up to 1 Gbps for seamless connectivity'
    },
    { 
      icon: 'fa-wifi',
      title: 'Nationwide',
      description: 'Expanding coverage to bring you the best internet experience'
    },
  ];

  return (
    <section id="coverage" className="coverage py-5 position-relative overflow-hidden">
      {/* Background Elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: -1 }}>
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-light opacity-10"></div>
        <div className="position-absolute bottom-0 end-0 w-50 h-50 bg-primary rounded-circle opacity-05" style={{
          transform: 'translate(30%, 30%)',
          filter: 'blur(100px)'
        }}></div>
      </div>

      <div className="container position-relative">
        <div className="text-center mb-5" data-aos="fade-up">
          <span className="badge bg-primary bg-opacity-10 text-primary px-4 py-2 rounded-pill d-inline-block mb-3">
            <i className="fas fa-map-marked-alt me-2"></i> Our Network
          </span>
          <h2 className="display-5 fw-bold mb-3">Nationwide Coverage</h2>
          <p className="lead text-muted max-w-3xl mx-auto">
            Experience seamless connectivity with our expanding network across Pakistan's major cities
          </p>
        </div>

        <div className="row g-5 align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="coverage-map-container position-relative rounded-4 overflow-hidden shadow-lg" style={{ height: '450px' }}>
              {/* Static Map Image */}
              <div style={{ 
                position: 'relative', 
                width: '100%', 
                height: '100%',
                backgroundImage: `url(${mapImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '0.5rem'
              }}>
              </div>
              
           
            </div>
          </div>
          
          <div className="col-lg-6" data-aos="fade-left">
            <div className="ps-lg-5">
              <h3 className="h4 mb-4 fw-bold">
                <i className="fas fa-wifi text-primary me-2"></i>
                {cities.find(c => c.id === activeTab)?.name} Coverage
              </h3>
              
              <div className="progress mb-4" style={{ height: '10px', borderRadius: '5px' }}>
                <div 
                  className="progress-bar bg-primary" 
                  role="progressbar" 
                  style={{ 
                    width: cities.find(c => c.id === activeTab)?.coverage,
                    borderRadius: '5px',
                    background: 'linear-gradient(90deg, #00c6ff, #0072ff)'
                  }}
                  aria-valuenow="90" 
                  aria-valuemin="0" 
                  aria-valuemax="100"
                ></div>
              </div>
              
              <div className="row g-3 mb-4">
                {features.map((feature, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="d-flex">
                      <div className="icon-box bg-primary bg-opacity-10 rounded-3 p-3 me-3" style={{ width: '50px', height: '50px' }}>
                        <i className={`fas ${feature.icon} text-primary`}></i>
                      </div>
                      <div>
                        <h6 className="mb-1 fw-bold">{feature.title}</h6>
                        <p className="small text-muted mb-0">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="d-flex flex-wrap gap-3 mt-4">
                <a href="#contact" className="btn btn-primary px-4 rounded-pill">
                  Check Availability <i className="fas fa-arrow-right ms-2"></i>
                </a>
                <a href="#packages" className="btn btn-outline-primary px-4 rounded-pill">
                  View Packages
                </a>
              </div>
              
              <div className="alert alert-light mt-4 d-flex align-items-center" role="alert">
                <i className="fas fa-info-circle text-primary me-2"></i>
                <div>
                  <small className="text-muted">
                    Don't see your area? We're expanding rapidly! 
                    <a href="#contact" className="text-primary fw-medium">Contact us</a> to request coverage in your location.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};



export default Coverage;
